import ArchiveDetail from "../components/ArchiveDetail/ArchiveDetail";

export default function ArchiveDetailPage() {
	return <ArchiveDetail />;
}
